
import { mapActions, mapState } from 'vuex'
import { mdiArrowLeft, mdiArrowRight } from '@mdi/js'
import NewProductDetails from '@/components/catalog/product/NewProductDetails'
import utils from '@/components/tools/utils'
import LoadingContainer from '@/components/ui/LoadingContainer'
import QuestionsAndAnswers from '@/components/catalog/product/QuestionsAndAnswers'
import time from '@/components/tools/time'

export default {
  components: {
    QuestionsAndAnswers,
    LoadingContainer,
    NewProductDetails
  },
  props: {
    backToMyVehicles: {
      type: Boolean,
      default: false
    },
    backToMyMessages: {
      type: Boolean,
      default: false
    },
    entityId: {
      type: Number,
      required: true
    }
  },
  timeout: null,

  data: () => ({
    mdiArrowRight,
    mdiArrowLeft,
    dialog: false

  }),
  async fetch () {
    await Promise.all([
      this.getAttributes(),
      this.getAttributesDe(),
      this.getProduct(this.entityId)
    ])

    const locale = this.$i18n.locale
    if (locale !== 'de') {
      await Promise.all([
        this.getTranslatedDescription({
          entityId: this.entityId,
          storeCode: locale,
          description: this.product.description
        }),
        this.getTranslatedDefectsDescription({
          entityId: this.entityId,
          storeCode: locale,
          description: this.product.defectsDescription
        })
      ])
    }
  },
  head () {
    return {
      meta: [
        {
          name: 'robots',
          content: 'noindex'
        },
        {
          hid: 'og:title',
          name: 'og:title',
          content: this.title
        },
        {
          hid: 'og:description',
          name: 'og:description',
          content: this.description
        },
        {
          name: 'og:image',
          content: this.imageUrl
        }
      ]
    }
  },

  computed: {
    waitingForAnswer: {
      get () {
        return this.$store.state.product.data?.context?.waitingForAnswer
      },
      set (value) {
        this.$store.commit('product/setWaitingForAnswer', value)
      }
    },

    ...mapState('customer', {
      customer: state => state.customer
    }),
    ...mapState('product', {
      product: state => state.data,
      status: state => state.data?.auction?.status,
      image: state => state.data?.image,
      endingAt: state => state.data?.auction?.endingAt
    }),
    isOwner () {
      return this.$auth.loggedIn && this.customer?.customerId && this.customer?.customerId === this.product?.customerId
    },
    imageUrl () {
      return utils.imageUri(this, this.image)
    },
    title () {
      return `caravanmarkt24.de - ${this.product?.title}`
    },

    description () {
      if (this.isOwner) {
        return this.$t('social.fb_description_owner')
      } else {
        return this.$t('social.fb_description_bidder')
      }
    },
    hasBiddingContext () {
      return !(this.product?.context?.holdingHighestBid === undefined || this.product?.context?.holdingHighestBid === null)
    }

  },
  mounted () {
    this.longPollCheckedGetProduct()
  },
  beforeDestroy () {
    this.clearTimeoutIfExist()
    this.$store.commit('product/setProduct', {})
  },

  methods: {
    ...mapActions('product', ['getProduct', 'getTranslatedDescription', 'getTranslatedDefectsDescription', 'getCheckedProduct']),
    ...mapActions('upload', ['getAttributes', 'getAttributesDe']),

    async backToSearchResults () {
      await this.$router.go(-1)
    },

    async goToMyVehicles () {
      await this.$router.push(this.localePath({
        name: 'account-products'
      }))
    },
    onSubmitted () {
      this.dialog = false
    },

    longPollCheckedGetProduct () {
      try {
        // if auction has ended, do not poll
        if (['failed', 'renegotiation', 'sold'].includes(this.product.auction?.status)) {
          // console.log('auction has ended... stopping polling')
          return
        }

        const defaultInterval = 5000

        if (!this.product.auction?.status ||
          !this.product.auction?.endingAt ||
          !this.product.auction?.currentPrice ||
          !this.hasBiddingContext) {
          // console.log('product not loaded yet or no bidding context exists... checking again in 5 seconds')

          this.clearTimeoutIfExist()
          this.$options.timeout = setTimeout(() => {
            this.longPollCheckedGetProduct()
          }, defaultInterval)
          return
        }

        const hotbiddingStarted = utils.lessThan30SecondsUntilThen(Date.now(), time.parseDate(this.product.auction.endingAt))
        const interval = hotbiddingStarted ? 1000 : defaultInterval

        this.clearTimeoutIfExist()
        this.$options.timeout = setTimeout(async () => {
          try {
            // console.log('polling...')
            await this.getCheckedProduct(
              { entityId: this.entityId, currentPrice: this.product.auction.currentPrice })
            // console.log('polling done')
          } catch (e) {
            console.error(e)
          } finally {
            this.longPollCheckedGetProduct()
          }
        }, interval)
      } catch (e) {
        console.error(e)
      }
    },

    clearTimeoutIfExist () {
      if (this.$options.timeout) {
        // console.log('clearing timeout')
        clearTimeout(this.$options.timeout)
      }
    }
  }

}
